import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API } from '../../config';
import {
    GET_NEWS_FEEDS,
    getNewsFeedsSuccess,
    getNewsFeedsFailure,
    SEARCH_COUNTERPARTY_NAME,
    searchCounterpartyNameSuccess,
    searchCounterpartyNameFailure,
    SUBMIT_NEWS_FEED,
    submitNewsFeedSuccess,
    submitNewsFeedFailure,
} from './action';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';

export function* newsFeeds(action) {
    let requestURL = `${CORE_API}/newsfeed/list/PENDING/${action.pageCount}/${action.newsFeedsPerPage}`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(getNewsFeedsSuccess(result.data));
    } catch (err) {
        yield put(getNewsFeedsFailure(err))
    }
}
export function* getNewsFeedsSaga() {
    yield takeLatest(GET_NEWS_FEEDS, newsFeeds);
}

export function* counterpartyNameResults(action) {
    let requestURL = `${CORE_API}/counterparty/autocomplete/name/${action.data}`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(searchCounterpartyNameSuccess(result.data));
    } catch (err) {
        yield put(searchCounterpartyNameFailure(err))
    }
}
export function* searchCounterpartyNameSaga() {
    yield takeLatest(SEARCH_COUNTERPARTY_NAME, counterpartyNameResults);
}

export function* submitNewsFeeds(action) {
    let requestURL = `${CORE_API}/newsfeed/update/${action.data.id}`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        yield put(submitNewsFeedSuccess(result.data));
        yield put({ type: GET_NEWS_FEEDS, pageCount: action.pageCount, newsFeedsPerPage: action.newsFeedsPerPage })
    } catch (err) {
        yield put(submitNewsFeedFailure(err))
    }
}
export function* submitNewsFeedsSaga() {
    yield takeLatest(SUBMIT_NEWS_FEED, submitNewsFeeds);
}

